<template>
  <v-app>
    </v-app>
</template>


<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>
import axios from 'axios';
import config from '@/../config.js'

export default {
    mounted : function () {
        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.public.queue.get_stationdetail
            ,{station_code:this.$route.params.station_code}
        ).then(response_stationdetail => {
            console.log(response_stationdetail.data.queue_url)
            if(response_stationdetail.data.queue_url.length==0 || !response_stationdetail.data.queue_url.includes("http")){
                response_stationdetail.data.queue_url = "https://sites.google.com/view/9ma-nad/home"
            }
            this.$store.commit('finishLoading',que)
            window.location.href = response_stationdetail.data.queue_url
        })
    }
}
</script>
